export default __webpack_public_path__ + "static/media/twitter-bird-small.62ec98d3.png";